import { SCREENS } from "utils/constants";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ORGANIZATION.TRAILS.LIST.path,
    exact: true,
    element: <List />,
  },
];

export default routes;
